module.exports = __webpack_public_path__ + "static/media/py.a70b32d0.svg";